export function IconBoleto() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" viewBox="0 0 203 138"><path xmlns="http://www.w3.org/2000/svg" fill="#435F7A" d="M0 138h9V0H0v138zm194 0h9V0h-9v138zm-19 0h10V0h-10v138zm-37 0h28V0h-28v138zm-27 0h18V0h-18v138zm-28 0h9V0h-9v138zm-28 0h19V0H55v138zm-36 0h27V0H19v138z"/></svg>
    )
}
